"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionsResponseType = void 0;
const defaults_1 = require("./defaults");
const section_1 = __importDefault(require("./section"));
const session_1 = __importDefault(require("./session"));
var SectionsResponseType;
(function (SectionsResponseType) {
    SectionsResponseType["CONTENT_SECTION"] = "CONTENT_SECTION";
    SectionsResponseType["SESSION"] = "SESSION";
})(SectionsResponseType = exports.SectionsResponseType || (exports.SectionsResponseType = {}));
function isSection(v) {
    return v.content_type === SectionsResponseType.CONTENT_SECTION;
}
const SectionsResponse = (data) => {
    const modeledData = data.data.map((d) => {
        if (isSection(d)) {
            return new section_1.default(defaults_1.defaultObject({ ...d.data, next: d.next, previous: d.previous }));
        }
        return new session_1.default(defaults_1.defaultObject({ ...d.data, next: d.next, previous: d.previous }));
    });
    return {
        ...data,
        data: modeledData,
    };
};
exports.default = {
    SectionsResponse,
};
